// © 2023 Amazon Web Services, Inc. or its affiliates. All Rights Reserved.
// This AWS Content is provided subject to the terms of the AWS Customer Agreement available at
// http://aws.amazon.com/agreement or other written agreement between Customer and either
// Amazon Web Services, Inc. or Amazon Web Services EMEA SARL or both.
import React, { useEffect, useState } from "react";
import { Hub } from 'aws-amplify/utils';
import { autoSignIn, signInWithRedirect, fetchAuthSession } from 'aws-amplify/auth';
import { Spin, Layout } from "antd";
import Nav from "./components/Navigation/Nav";
import home from "./media/Home.svg";
import "./index.css";
import { Button } from "@awsui/components-react";

const { Header, Content } = Layout;

function Home(props) {
  // Only show spinner, never redirect here. All redirect logic is in getUser/setData.
  return (
    <Layout className="site-layout">
      <Header className="site-layout-background" style={{ padding: 0 }} />
      <Content className="layout">
        <Spin spinning={props.loading} size="large">
          <img src={home} alt="Homepage" className="home" />
        </Spin>
      </Content>
    </Layout>
  );
}
function App() {
  const [user, setUser] = useState(null);
  const [groups, setGroups] = useState(null);
  const [cognitoGroups, setcognitoGroups] = useState([]);
  const [userId, setUserId] = useState(null);
  const [groupIds, setGroupIds] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    Hub.listen("auth", ({ payload: { event, data } }) => {
      // eslint-disable-next-line default-case
      switch (event) {
        case "signIn":
          console.log("User signed in");
          break;
        // eslint-disable-next-line no-fallthrough
        case "cognitoHostedUI":
          setData();
          break;
        case "signOut":
          console.log("User signed out");
          setLoading(false);
          break;
        case "signIn_failure":
          console.log("User sign in failure");
          break;
        case "cognitoHostedUI_failure":
          console.log("Sign in failure");
          break;
      }
    });

    setData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function setData() {
    getUser().then(async (session) => {
      if (!session) return; // getUser handles redirect if not signed in
      let payload = {};
      try {
        const idToken = session.tokens?.idToken?.toString();
        if (idToken) {
          payload = JSON.parse(atob(idToken.split('.')[1]));
        }
      } catch (err) {
        console.log("Could not fetch session or decode token", err);
      }

      // Pass user info as a flat object
      setUser({
        email: payload.email || "",
        username: payload["cognito:username"] || payload["username"] || "",
        ...payload
      });
      setcognitoGroups(payload["cognito:groups"]);
      setUserId(payload["userId"] || "");
      setGroupIds((payload["groupIds"] || "").split(','));
      setGroups((payload["groups"] || "").split(','));
      setLoading(false);
    });
  }

  async function getUser() {
    setLoading(true);
    try {
      console.log("Fetching auth session...");
      const userData = await fetchAuthSession();
      return userData;
    } catch (err) {
      // If not signed in, try autoSignIn (only works after Hosted UI redirect)
      if (err.name === "NotAuthorizedException" || err.message?.includes("NotAuthorizedException")) {
        try {
          const autoSignInResult = await autoSignIn();
          console.debug("autoSignIn result:", autoSignInResult);
          if (autoSignInResult?.isSignedIn) {
            const userData = await fetchAuthSession();
            return userData;
          } else {
            setLoading(false);
            signInWithRedirect();
            return null;
          }
        } catch (autoErr) {
          setLoading(false);
          signInWithRedirect();
          return null;
        }
      } else {
        setLoading(false);
        console.log("Not signed in", err);
        return null;
      }
    }
  }

  return (
    <div>
      {user ? (
        <Nav
          user={user}
          groupIds={groupIds}
          userId={userId}
          groups={groups}
          cognitoGroups={cognitoGroups}
        />
      ) : (
        <Home loading={loading} />
      )}
    </div>
  );
}

export default App;
